import cacheKeys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as keysAPI from '@debbie/cortex/dist/api/keys.js';
import { h } from '@debbie/cortex/dist/index.js';
import { keysEntity, useKeys } from '@debbie/cortex/dist/keys/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../utils/errors.js';
import Button from '../Button.js';
import Error from '../Messages/Error.js';
import Modal from '../Modal.js';
import Panel from '../Panel.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Table from '../Table.js';
const PowerBiKeys = (props) => {
    const lang = useSelector((s) => s.lang);
    const labels = lang.insights.powerbi;
    const loadable = useKeys(props.creditorId);
    const [revoking, setRevoking] = useState(null);
    const revoke = useMutation((id) => keysAPI.del(id, props.creditorId), {
        onSuccess: (_, id) => {
            q.invalidate(cacheKeys.write.modify(keysEntity, id));
            props.onRevoke(id);
            setRevoking(null);
        },
        onError: (error) => errorNotification(lang, error, 'delete', lang.errorEntities.apiKey),
    });
    const keys = h.hasData(loadable)
        ? loadable.data.filter((key) => key.scopes.some((scope) => scope.startsWith('read:insights.')))
        : [];
    return (React.createElement(Panel, { header: lang.apiSettings.keys },
        React.createElement("p", null, labels.keysDescription),
        h.isError(loadable) ? (React.createElement(Error, { messages: [loadable.error.message] })) : !h.hasData(loadable) ? (React.createElement(PlaceholderLoader, null)) : keys.length === 0 ? (React.createElement("p", null, lang.apiSettings.noKeysYet)) : (React.createElement(Table, { columns: [
                { title: lang.apiSettings.keyName },
                { title: labels.dataSources },
                { title: labels.issuedAt },
                { title: '' },
            ], overflowX: "auto" }, keys.map((key) => (React.createElement("tr", { key: key.id },
            React.createElement("td", null,
                React.createElement("b", null, key.name)),
            React.createElement("td", null,
                React.createElement("ul", null, key.scopes.map((scope) => (React.createElement("li", { key: scope }, lang.insights.apiTypes[scope.replace('read:insights.', '')] ?? scope))))),
            React.createElement("td", null, new Date(key.createdAt).toLocaleString()),
            React.createElement("td", null,
                React.createElement(Button, { size: "small", theme: "dangerous", onClick: () => setRevoking(key) }, labels.revoke))))))),
        revoking !== null && (React.createElement(Modal, { header: labels.revoke, onToggle: () => {
                if (!revoke.isLoading) {
                    setRevoking(null);
                }
            }, maxWidth: "550px" },
            React.createElement("p", null,
                React.createElement("b", null, revoking.name)),
            React.createElement("p", null, labels.revokeWarning),
            React.createElement(Button, { theme: "dangerous", loading: revoke.isLoading, onClick: () => {
                    void revoke.mutate(revoking.id);
                } }, labels.revoke)))));
};
export default PowerBiKeys;
//# sourceMappingURL=PowerBiKeys.js.map